function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.8125 2.25H24.125V1.125C24.125 0.505125 23.6199 0 23 0H20.75C20.1301 0 19.625 0.505125 19.625 1.125V2.25H16.25V1.125C16.25 0.505125 15.7449 0 15.125 0H12.875C12.2551 0 11.75 0.505125 11.75 1.125V2.25H8.375V1.125C8.375 0.505125 7.86987 0 7.25 0H5C4.38013 0 3.875 0.505125 3.875 1.125V2.25H2.1875C1.25712 2.25 0.5 3.00712 0.5 3.9375V16.3125C0.5 17.2429 1.25712 18 2.1875 18H25.8125C26.7429 18 27.5 17.2429 27.5 16.3125V3.9375C27.5 3.00712 26.7429 2.25 25.8125 2.25Z"
});

function SvgIcAreaBuildingBlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAreaBuildingBlock);
export default ForwardRef;